import React from 'react';
import RevelataLogoSvgAnimated from '../static/RevelataLogoSvgAnimated.svg';
import { Box } from '@mui/material';

const SketchedLogoSpinner = ({ size = 48, sx = {} }) => {
    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            ...sx 
        }}>
            <img 
                src={RevelataLogoSvgAnimated} 
                alt="Revelata Logo" 
                height={size}
            />
        </Box>
    );
};

export default SketchedLogoSpinner; 
